<template>
    <li class="right-side">
        <div class="onhover-dropdown header-badge">

            <router-link :to="{name: !auth.isLoggedIn() ? 'login' :'cart_items.index', params: { lang : $i18n.locale  }}"
                         class="btn p-0 position-relative header-wishlist">
                <i data-feather="gift"></i>
                <span class="position-absolute top-0 start-100 translate-middle badge">
                    {{ cartItems.length }}
                    <span class="visually-hidden">The number of cart items</span>
                </span>
            </router-link>

            <div class="onhover-div" v-if="cartItems?.length > 0">
                <ul class="cart-list">
                    <li class="product-box-contain w-100" v-for="cartItem in cartItems" :key="cartItem.id">
                        <div class="drop-cart">
                            <router-link :to="{name: 'products.show', params: { id: cartItem.product.id , lang : $i18n.locale  }}"
                                         class="drop-image">
                                <img :src="cartItem.product.image ?? '/theme/assets/images/more/gift-card.png'" class="blur-up lazyload" :alt="cartItem.product.name">
                            </router-link>
                            <div class="drop-contain">
                                <router-link :to="{name: 'products.show', params: { id: cartItem.product.id , lang : $i18n.locale  }}">
                                    <h5>{{ cartItem.product.name }}</h5>
                                </router-link>

                                <h6 v-if="cartItem.selected_price !== null"><span>{{ cartItem.selected_price.name }}</span></h6>
                                <h6><span>{{ cartItem.quantity }} x</span>  {{ cartItem.selected_price?.price_tax || cartItem.product.price_tax }} {{ $t('SAR') }}</h6>

                                <div class="text-content" v-for="(attribute, attributeId) in cartItem.product.attributes" :key="attributeId">
                                    <span class="text-title"> {{ attribute?.data?.name }} : </span>
                                    <span>{{ getSelectedAttributeValue(attributeId, cartItem) }}</span>
                                </div>

                                <button class="close-button close_button" @click="removeFromCart(cartItem?.id)">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="price-box">
                    <h5>{{ $t('Subtotal') }} :</h5>
                    <h4 class="theme-color fw-bold">{{ subtotal }} {{ $t('SAR') }}</h4>
                </div>
                <div class="button-group d-flex align-items-end">
                    <router-link :to="{name: 'cart_items.index', params: { lang : $i18n.locale  }}"
                                 class="btn btn-sm cart-button"> {{ $t('View Cart') }}</router-link>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    inject: ['auth'],
    computed: {
        ...mapGetters(['cartItems', 'getSelectedAttributeValue', 'subtotal', 'tax', 'total']), // ربط getters مع المكون
    },
    methods: {
        ...mapActions(['addToCart', 'removeFromCart']),
    },
};
</script>

<style scoped>
/* Add your component-specific styles here */
</style>
